import { useEffect, useState } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { SnpApi } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { DEPRECATED_Loading } from "../DEPRECATED_Loading";

type UnsubscribeBlockType = {
  successMessage?: string;
  errorMessage?: string;
};

export const UnsubscribeBlock: React.FC<UnsubscribeBlockType> = ({ successMessage, errorMessage }) => {
  const [pending, setPending] = useState<boolean>(true);
  const [success, setSuccess] = useState<boolean>(false);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const topics = urlSearchParams.get("topics")?.split(",") || ["marketing"];
    const consentsIds = urlSearchParams.getAll("consent_id[]");
    SnpApi.init()
      .unsubscribe(urlSearchParams.get("subscriberUUID") || "", topics, consentsIds.length ? consentsIds : undefined)
      .then(() => {
        setSuccess(true);
        dispatchTrackingEvent(TrackingEvents.TrackingUnsubscribe);
      })
      .catch(() => {
        setSuccess(false);
      })
      .finally(() => {
        setPending(false);
      });
  }, []);

  if (pending) {
    return <DEPRECATED_Loading dataTestId="usubscribeLoader" />;
  }

  return (
    <div>
      <AlertBanner
        tone={success ? "success" : "error"}
        richDescription={<div data-testid="unsubscribe-message">{success ? successMessage : errorMessage}</div>}
      />
    </div>
  );
};
